module.exports = __webpack_public_path__ + "static/media/event4f2f12f5d8fb895d83fad039371ef750.webp";